import type { DatabaseAdapter } from "@rapid/providers/database/DatabaseAdapter";
import type { ActivityViewData, ActivityUIKind } from "../../types";

export enum ActivityEventKind {
    AsyncTask = "async_task",
    CIModelChange = "continuous_improvement_model_change"
}

export enum ActivityEventSeverity {
    NeedsAction = "needs_action",
    Notable = "notable",
    Routine = "routine"
}

export enum ActivityAudienceMode {
    All = "all",
    Permissions = "permissions",
    Users = "users"
}

export enum ActivityEntityType {
    AsyncTask = "async_task",
    RapidProject = "rapid_project"
}

export interface FirestoreActivityEvent {
    id: string;
    kind: ActivityEventKind;
    severity: ActivityEventSeverity;
    entity: { type: ActivityEntityType; id: string; url?: string };
    payload: Record<string, unknown>;
    audience: { mode: ActivityAudienceMode; targets?: string[] };
    owner: string;
    createdAt: any;
    updatedAt: any;
    ttlAt?: any;
}

export interface ActivityEventProvider {
    uiKind: ActivityUIKind;

    convert(event: FirestoreActivityEvent, enrichment?: unknown): ActivityViewData;

    subscribeToEnrichment?(
        event: FirestoreActivityEvent,
        onData: (data: unknown) => void,
        database: DatabaseAdapter
    ): () => void;
}
